import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const HotelDetails = () => {
  const { t } = useTranslation();
  return (
    <div className="card-box p-0">
      <div className="list-trip">
        <p className="mt-0">{t("Hotel")}</p>
        <h4>{t("FabHotel Awadhvue")}</h4>
        <p>
          {t(
            "EC-60, Ring Road, Near Bombay Hospital, Scheme No 94C, 452010 Indore, India"
          )}
        </p>
        <span className="green-text">
          <strong>{t("Great Location — 8.5")}</strong>
        </span>
        <div className="ex-bottom-text d-flex mt-4">
          <div className="text-box">
            <p className="m-0 p-0">{t("Excellent")}</p>
            <p className="m-0 p-0">{t("9 reviews")}</p>
          </div>
          <div className="link-btn-box"></div>
        </div>
      </div>

      <div className="list-trip">
        <h4 className="mt-0">{t("Your booking details")}</h4>
        <ul className="list-unstyled p-0 m-0 d-flex check-in-out-box">
          <li>
            {t("Check-in")} <br /> {t("Fri, Sep 26, 2025")} <br />{" "}
            {t("From 12:00 PM")}
          </li>
          <li>
            {t("Check-in")} <br /> {t("Fri, Sep 26, 2025")} <br />{" "}
            {t("From 12:00 PM")}
          </li>
        </ul>
        <p className="mb-0">{t("Total length of stay:")}</p>
        <p className="mt-0">{t("1 night")}</p>
        <div className="selected-box-acc">
          <div className="selected-box d-flex align-items-center gap-2">
            <div className="items-details">
              <p className="mb-0">{t("You selected")}</p>
              <h4 className="mt-0">{t("1 room for 2 adults")}</h4>
            </div>
            <div className="dropdown-box">
              <svg
                width="23"
                height="13"
                viewBox="0 0 23 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L11.5 11.5L22 1"
                  stroke="#C2C2C2"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div>
          <Link to="#" className="text-blue">
            {t("Change your selection")}
          </Link>
        </div>
      </div>

      <div className="list-trip">
        <h4>{t("Your price summary")}</h4>
        <ul className="price-listing-box list-unstyled p-0 m-0">
          <li className="d-flex justify-content-between gap-2">
            <span>{t("Original price")}</span>
            <span>₹ 4,224</span>
          </li>
          <li className="d-flex justify-content-between gap-2">
            <span>{t("Getaway Deal")}</span>
            <span>- ₹ 1,943.04</span>
          </li>
        </ul>
        <div className="bottom-text">
          <span>
            {t(
              "This property is offering a discount on stays between Mar 28 and Sep 30, 2025."
            )}
          </span>
        </div>
      </div>

      <div className="list-trip final-price-box d-flex align-items-center gap-2 justify-content-between">
        <h4 className="m-0 p-0">{t("Price")}</h4>
        <div className="price-right text-end">
          <span className="sub-price"> ₹ 4,224</span>
          <h4 className="m-0 p-0">₹ 2,280.96</h4>
          <div className="bottom-text">
            <span>{t("+₹ 274 taxes and fees")}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelDetails;
